(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6121],{

/***/ 25498:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/designers",
      function () {
        return __webpack_require__(24784);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 68971:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ PageViewAnalytics; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _unlikelystudio_react_ecommerce_hooks__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13711);



function PageViewAnalytics(param) {
    var template = param.template;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var pathname = "".concat(router === null || router === void 0 ? void 0 : router.locale).concat(router === null || router === void 0 ? void 0 : router.pathname);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_unlikelystudio_react_ecommerce_hooks__WEBPACK_IMPORTED_MODULE_2__/* .PageViewAnalytics */ .WA, {
        template: template,
        pathname: pathname
    });
}


/***/ }),

/***/ 64191:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19845);
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames_bind__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _types_colors__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(37444);
/* harmony import */ var _types_text_preset__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(95348);
/* harmony import */ var _types_text_styling__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(36575);
/* harmony import */ var _unlikelystudio_react_slider__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(7924);
/* harmony import */ var _components_UI_InlineCta__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(85499);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(39100);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_8__);











var cx = classnames_bind__WEBPACK_IMPORTED_MODULE_1___default().bind((_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default()));
function GridListNav(param) {
    var className = param.className, links = param.links;
    var customSliderRef = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)();
    var query = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)().query;
    var ref;
    var filterValue = (ref = query === null || query === void 0 ? void 0 : query.uid) !== null && ref !== void 0 ? ref : null;
    var isFiltering = !!filterValue;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: cx((_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().GridListNav), className),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().wrapper),
            ref: customSliderRef,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_unlikelystudio_react_slider__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, {
                className: cx((_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().slider)),
                autoIsSlider: true,
                customSliderRef: customSliderRef,
                children: links === null || links === void 0 ? void 0 : links.map(function(link, index) {
                    var isActive = index === 0 ? !isFiltering : filterValue && link.href.toString().indexOf("".concat(filterValue)) > -1;
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_UI_InlineCta__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({
                        className: cx((_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().link), {
                            isActive: isActive
                        }),
                        textPreset: _types_text_preset__WEBPACK_IMPORTED_MODULE_5__/* .GlobalTextPreset.Cta12Grotesk */ .C.Cta12Grotesk,
                        textStyling: _types_text_styling__WEBPACK_IMPORTED_MODULE_6__/* .GlobalTextStyling.UpperCase */ .l.UpperCase,
                        theme: isActive ? _types_colors__WEBPACK_IMPORTED_MODULE_4__/* .GlobalThemeColors.Black */ .b.Black : _types_colors__WEBPACK_IMPORTED_MODULE_4__/* .GlobalThemeColors.SilverChalice */ .b.SilverChalice,
                        lineProps: {
                            initialLineState: isActive ? "underlined" : "none"
                        }
                    }, link), "link_right_".concat(index));
                })
            })
        })
    });
}
GridListNav.defaultProps = {};
/* harmony default export */ __webpack_exports__["Z"] = (GridListNav);


/***/ }),

/***/ 49035:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19845);
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames_bind__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _types_grid_preset__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31538);
/* harmony import */ var _types_text_preset__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(95348);
/* harmony import */ var _components_UI_GridListNav__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(64191);
/* harmony import */ var _providers_StyleProvider__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(60118);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(23802);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_7__);








var cx = classnames_bind__WEBPACK_IMPORTED_MODULE_1___default().bind((_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default()));
function HeroGridList(param) {
    var className = param.className, childrenClassName = param.childrenClassName, title = param.title, links = param.links, children = param.children;
    var gridStyle = (0,_providers_StyleProvider__WEBPACK_IMPORTED_MODULE_6__/* .useStyle */ .X)({
        grid: _types_grid_preset__WEBPACK_IMPORTED_MODULE_3__/* .GlobalGridPreset.BASE_GRID */ .H.BASE_GRID
    });
    var titleStyle = (0,_providers_StyleProvider__WEBPACK_IMPORTED_MODULE_6__/* .useStyle */ .X)({
        textPreset: _types_text_preset__WEBPACK_IMPORTED_MODULE_4__/* .GlobalTextPreset.Title40SangBleu */ .C.Title40SangBleu
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: cx((_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default().HeroGridList), className),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: cx((_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default().content), gridStyle),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default().left),
                    children: title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                        className: cx((_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default().title), titleStyle),
                        children: title
                    })
                }),
                children && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: cx((_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default().center), childrenClassName),
                    children: children
                }),
                (links === null || links === void 0 ? void 0 : links.length) > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default().right),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_UI_GridListNav__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        links: links,
                        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default().links)
                    })
                })
            ]
        })
    });
}
HeroGridList.defaultProps = {};
/* harmony default export */ __webpack_exports__["Z"] = (HeroGridList);


/***/ }),

/***/ 32915:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ UI_IndexList; }
});

// UNUSED EXPORTS: ListImageLayout

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/classnames/bind.js
var bind = __webpack_require__(19845);
var bind_default = /*#__PURE__*/__webpack_require__.n(bind);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/value/use-scroll.mjs + 11 modules
var use_scroll = __webpack_require__(79645);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/components/AnimatePresence/index.mjs + 5 modules
var AnimatePresence = __webpack_require__(51526);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion-minimal.mjs + 19 modules
var motion_minimal = __webpack_require__(57891);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-use/esm/useIsomorphicLayoutEffect.js
var useIsomorphicLayoutEffect = __webpack_require__(11042);
// EXTERNAL MODULE: ./src/@types/breakpoints.ts
var breakpoints = __webpack_require__(59646);
// EXTERNAL MODULE: ./src/@types/grid-preset.ts
var grid_preset = __webpack_require__(31538);
// EXTERNAL MODULE: ./src/components/Navigation/NavigationBanner/index.tsx
var NavigationBanner = __webpack_require__(64061);
// EXTERNAL MODULE: ./src/components/UI/Image/index.tsx
var Image = __webpack_require__(51025);
// EXTERNAL MODULE: ./src/@types/text-preset.ts
var text_preset = __webpack_require__(95348);
// EXTERNAL MODULE: ./node_modules/@unlikelystudio/react-abstract-components/dist/es/components/Link/index.js
var Link = __webpack_require__(13200);
// EXTERNAL MODULE: ./src/providers/StyleProvider/index.tsx
var StyleProvider = __webpack_require__(60118);
// EXTERNAL MODULE: ./src/components/UI/IndexList/IndexListItem/styles.module.scss
var styles_module = __webpack_require__(6769);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/components/UI/IndexList/IndexListItem/index.tsx









var cx = bind_default().bind((styles_module_default()));
function IndexListItem(param) {
    var className = param.className, forwardRef = param.forwardRef, index = param.index, title = param.title, link = param.link, isActive = param.isActive, onMouseEnter = param.onMouseEnter, onMouseOut = param.onMouseOut;
    var linkStyle = (0,StyleProvider/* useStyle */.X)({
        textPreset: text_preset/* GlobalTextPreset.Title20SangBleuLight */.C.Title20SangBleuLight
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        ref: forwardRef,
        className: cx((styles_module_default()).IndexListItem, linkStyle, className, {
            isActive: isActive
        }),
        onMouseEnter: function(e) {
            onMouseEnter && onMouseEnter(index);
        },
        onMouseLeave: function(e) {
            onMouseOut && onMouseOut();
        }
    }, link), {
        children: title
    }));
}
IndexListItem.defaultProps = {};
/* harmony default export */ var IndexList_IndexListItem = (IndexListItem);

// EXTERNAL MODULE: ./src/hooks/useBreakpoint/index.ts + 4 modules
var useBreakpoint = __webpack_require__(7695);
// EXTERNAL MODULE: ./src/components/UI/IndexList/styles.module.scss
var IndexList_styles_module = __webpack_require__(97595);
var IndexList_styles_module_default = /*#__PURE__*/__webpack_require__.n(IndexList_styles_module);
;// CONCATENATED MODULE: ./src/components/UI/IndexList/index.tsx

















var IndexList_cx = bind_default().bind((IndexList_styles_module_default()));
var ListImageLayout = {
    MULTIPLE: "multiple",
    SINGLE: "single"
};
var _obj;
var IMAGE_SIZES = (_obj = {}, (0,_define_property/* default */.Z)(_obj, ListImageLayout.MULTIPLE, [
    {
        breakpoint: "md",
        ratio: 1 / 5
    },
    {
        ratio: 1 / 4
    }, 
]), (0,_define_property/* default */.Z)(_obj, ListImageLayout.SINGLE, [
    {
        breakpoint: "md",
        ratio: 1 / 4
    },
    {
        ratio: 6 / 16
    }, 
]), _obj);
function IndexList(param) {
    var className = param.className, hasImageHasBackground = param.hasImageHasBackground, hasMultipleImages = param.hasMultipleImages, hasAlphabetFilter = param.hasAlphabetFilter, currentLetter = param.currentLetter, items = param.items;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    var listRef = (0,react.useRef)(null);
    var ref8 = (0,react.useState)(false), isMounted = ref8[0], setIsMounted = ref8[1];
    var itemsRefs = (0,react.useRef)([]);
    var gridStyle = (0,StyleProvider/* useStyle */.X)({
        grid: grid_preset/* GlobalGridPreset.BASE_GRID */.H.BASE_GRID
    });
    var isMobile = (0,useBreakpoint/* default */.Z)(breakpoints/* GLOBAL_BREAKPOINTS.MD */.L.MD);
    var ref9 = (0,react.useState)(0), activeIndex = ref9[0], setActiveIndex = ref9[1];
    var ref10 = (0,_sliced_to_array/* default */.Z)((0,NavigationBanner/* useNavBannerContext */.DI)(), 1), isVisible = ref10[0];
    var scrollY = (0,use_scroll/* useScroll */.v)().scrollY;
    var memoizedItems = (0,react.useMemo)(function() {
        var ref, ref1;
        var ref2;
        return {
            listOffsetTop: (ref2 = listRef === null || listRef === void 0 ? void 0 : (ref = listRef.current) === null || ref === void 0 ? void 0 : ref.offsetTop) !== null && ref2 !== void 0 ? ref2 : 0,
            items: itemsRefs === null || itemsRefs === void 0 ? void 0 : (ref1 = itemsRefs.current) === null || ref1 === void 0 ? void 0 : ref1.map(function(item, index) {
                var ref;
                var initialOffset = listRef === null || listRef === void 0 ? void 0 : (ref = listRef.current) === null || ref === void 0 ? void 0 : ref.offsetTop;
                var computedOffsetTop = (item === null || item === void 0 ? void 0 : item.offsetTop) - initialOffset;
                return {
                    index: index,
                    topOffset: computedOffsetTop,
                    bottomOffset: computedOffsetTop + (item === null || item === void 0 ? void 0 : item.clientHeight)
                };
            })
        };
    }, [
        itemsRefs,
        listRef,
        itemsRefs.current,
        listRef.current,
        isMounted,
        currentLetter, 
    ]);
    var onScroll = function(y) {
        var ref;
        var computedY = y;
        memoizedItems === null || memoizedItems === void 0 ? void 0 : (ref = memoizedItems.items) === null || ref === void 0 ? void 0 : ref.forEach(function(item) {
            if (computedY >= (item === null || item === void 0 ? void 0 : item.topOffset) && computedY <= (item === null || item === void 0 ? void 0 : item.bottomOffset)) {
                setActiveIndex(item === null || item === void 0 ? void 0 : item.index);
            }
        });
    };
    (0,react.useEffect)(function() {
        var ref;
        if ((memoizedItems === null || memoizedItems === void 0 ? void 0 : (ref = memoizedItems.items) === null || ref === void 0 ? void 0 : ref.length) > 0 && isMobile) {
            scrollY.onChange(function(latest) {
                onScroll(latest);
            });
        }
    }, [
        memoizedItems
    ]);
    var onMouseEnter = function(index) {
        if (!isMobile) {
            setActiveIndex(index);
        }
    };
    var ref11 = (0,react.useState)(0), loaded = ref11[0], setLoaded = ref11[1];
    var memoizedFilteredItems = (0,react.useMemo)(function() {
        return {
            items: hasAlphabetFilter && currentLetter ? items === null || items === void 0 ? void 0 : items.filter(function(item) {
                return item.firstLetter === currentLetter;
            }) : items
        };
    }, [
        hasAlphabetFilter,
        currentLetter
    ]);
    var activeImageSet = activeIndex !== null ? hasMultipleImages ? (ref4 = [
        memoizedFilteredItems === null || memoizedFilteredItems === void 0 ? void 0 : (ref = memoizedFilteredItems.items) === null || ref === void 0 ? void 0 : (ref1 = ref[activeIndex]) === null || ref1 === void 0 ? void 0 : ref1.cardImage,
        memoizedFilteredItems === null || memoizedFilteredItems === void 0 ? void 0 : (ref2 = memoizedFilteredItems.items) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[activeIndex]) === null || ref3 === void 0 ? void 0 : ref3.cardSecondImage, 
    ]) === null || ref4 === void 0 ? void 0 : ref4.filter(function(image) {
        return image;
    }) : [
        memoizedFilteredItems === null || memoizedFilteredItems === void 0 ? void 0 : (ref5 = memoizedFilteredItems.items) === null || ref5 === void 0 ? void 0 : (ref6 = ref5[activeIndex]) === null || ref6 === void 0 ? void 0 : ref6.cardImage
    ] : null;
    (0,react.useEffect)(function() {
        if (hasAlphabetFilter && currentLetter) {
            setActiveIndex(0);
        }
    }, [
        hasAlphabetFilter,
        currentLetter
    ]);
    (0,useIsomorphicLayoutEffect/* default */.Z)(function() {
        setIsMounted(true);
    }, []);
    (0,react.useEffect)(function() {
        setLoaded(0);
    }, [
        activeIndex
    ]);
    var imageSizes = hasMultipleImages ? IMAGE_SIZES[ListImageLayout.MULTIPLE] : IMAGE_SIZES[ListImageLayout.SINGLE];
    var variants = {
        visible: {
            opacity: 1,
            transition: {
                duration: 0.25
            }
        },
        hidden: {
            opacity: 0,
            transition: {
                duration: 0.05
            }
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: IndexList_cx((IndexList_styles_module_default()).IndexList, className, {
            hasImageHasBackground: hasImageHasBackground,
            isBannerVisible: isVisible
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: IndexList_cx(gridStyle, (IndexList_styles_module_default()).grid),
            children: [
                activeImageSet && (activeImageSet === null || activeImageSet === void 0 ? void 0 : activeImageSet.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(motion_minimal.m.div, {
                        className: IndexList_cx((IndexList_styles_module_default()).images, {
                            hasMultipleImages: hasMultipleImages,
                            hasImageHasBackground: hasImageHasBackground
                        }),
                        initial: variants.hidden,
                        variants: variants,
                        animate: loaded === (activeImageSet === null || activeImageSet === void 0 ? void 0 : activeImageSet.length) ? "visible" : "hidden",
                        children: activeImageSet === null || activeImageSet === void 0 ? void 0 : activeImageSet.map(function(image, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: IndexList_cx((IndexList_styles_module_default()).imageWrapper, {}),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, image), {
                                    layout: hasMultipleImages ? "fill" : "responsive",
                                    objectFit: hasMultipleImages ? "cover" : null,
                                    sizesFromBreakpoints: imageSizes,
                                    ratio: hasMultipleImages ? (IndexList_styles_module_default()).ratio : null,
                                    className: (IndexList_styles_module_default()).imageItem,
                                    priority: true,
                                    asPlaceholder: false,
                                    onLoadingComplete: function() {
                                        return setLoaded(function(e) {
                                            return e + 1;
                                        });
                                    }
                                }))
                            }, "image_".concat(index));
                        })
                    })
                }),
                items && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (IndexList_styles_module_default()).list,
                    ref: listRef,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (IndexList_styles_module_default()).marker
                        }),
                        memoizedFilteredItems === null || memoizedFilteredItems === void 0 ? void 0 : (ref7 = memoizedFilteredItems.items) === null || ref7 === void 0 ? void 0 : ref7.map(function(item, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(IndexList_IndexListItem, (0,_object_spread/* default */.Z)({
                                forwardRef: function(element) {
                                    itemsRefs.current[index] = element;
                                },
                                onMouseEnter: onMouseEnter,
                                isActive: activeIndex === index,
                                index: index,
                                className: (IndexList_styles_module_default()).item
                            }, item), "index_list_item_".concat(index));
                        })
                    ]
                })
            ]
        })
    });
}
IndexList.defaultProps = {};
/* harmony default export */ var UI_IndexList = (IndexList);


/***/ }),

/***/ 24784:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ designers; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/PageViewAnalytics/index.tsx
var PageViewAnalytics = __webpack_require__(68971);
// EXTERNAL MODULE: ./src/components/UI/HeroGridList/index.tsx
var HeroGridList = __webpack_require__(49035);
// EXTERNAL MODULE: ./src/components/UI/IndexList/index.tsx + 1 modules
var IndexList = __webpack_require__(32915);
// EXTERNAL MODULE: ./node_modules/classnames/bind.js
var bind = __webpack_require__(19845);
var bind_default = /*#__PURE__*/__webpack_require__.n(bind);
// EXTERNAL MODULE: ./node_modules/react-polyglot/lib/index.js
var lib = __webpack_require__(14408);
// EXTERNAL MODULE: ./src/@types/colors.ts
var colors = __webpack_require__(37444);
// EXTERNAL MODULE: ./src/@types/text-preset.ts
var text_preset = __webpack_require__(95348);
// EXTERNAL MODULE: ./src/components/UI/InlineCta/index.tsx + 1 modules
var InlineCta = __webpack_require__(85499);
// EXTERNAL MODULE: ./src/data/dictionary/index.ts + 1 modules
var dictionary = __webpack_require__(9554);
// EXTERNAL MODULE: ./src/components/UI/IndexList/IndexListAlphabetFilters/styles.module.scss
var styles_module = __webpack_require__(4995);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/components/UI/IndexList/IndexListAlphabetFilters/index.tsx









var cx = bind_default().bind((styles_module_default()));
function IndexListAlphabetFilters(param) {
    var className = param.className, letters = param.letters, currentLetter = param.currentLetter, onClickLetter = param.onClickLetter;
    var t = (0,lib/* useTranslate */.qM)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: cx((styles_module_default()).IndexListAlphabetFilters, className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InlineCta/* default */.Z, {
                textPreset: text_preset/* GlobalTextPreset.Cta12Grotesk */.C.Cta12Grotesk,
                theme: !currentLetter ? colors/* GlobalThemeColors.Black */.b.Black : colors/* GlobalThemeColors.Gray */.b.Gray,
                className: cx((styles_module_default()).letter, (styles_module_default()).letterAll),
                onClick: function(e) {
                    e.preventDefault();
                    onClickLetter && onClickLetter(null);
                },
                lineProps: {
                    initialLineState: !currentLetter ? "underlined" : "none"
                },
                children: t(dictionary/* LABEL.ALL */.GP.ALL)
            }),
            letters === null || letters === void 0 ? void 0 : letters.map(function(letterItem, index) {
                var isActive = letterItem.letter === currentLetter;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(InlineCta/* default */.Z, {
                    textPreset: text_preset/* GlobalTextPreset.Cta12Grotesk */.C.Cta12Grotesk,
                    theme: isActive ? colors/* GlobalThemeColors.Black */.b.Black : colors/* GlobalThemeColors.Gray */.b.Gray,
                    className: cx((styles_module_default()).letter, {
                        isNotClickable: !(letterItem === null || letterItem === void 0 ? void 0 : letterItem.isClickable)
                    }),
                    onClick: function(e) {
                        if (letterItem.isClickable) {
                            e.preventDefault();
                            onClickLetter && onClickLetter(letterItem.letter);
                        }
                    },
                    lineProps: {
                        initialLineState: isActive ? "underlined" : "none"
                    },
                    children: letterItem.letter
                }, "letter_".concat(index));
            })
        ]
    });
}
IndexListAlphabetFilters.defaultProps = {};
/* harmony default export */ var IndexList_IndexListAlphabetFilters = (IndexListAlphabetFilters);

// EXTERNAL MODULE: ./src/pages/designers/styles.module.scss
var designers_styles_module = __webpack_require__(51485);
var designers_styles_module_default = /*#__PURE__*/__webpack_require__.n(designers_styles_module);
;// CONCATENATED MODULE: ./src/pages/designers/index.tsx









function DesignerListPage(param) {
    var hero = param.hero, grid = param.grid, lettersList = param.lettersList;
    var ref = (0,react.useState)(null), currentLetter = ref[0], setCurrentLetter = ref[1];
    var onChangeLetter = function(letter) {
        if (letter === currentLetter) {
            setCurrentLetter(null);
        } else {
            setCurrentLetter(letter);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: (designers_styles_module_default()).DesignerListPage,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (designers_styles_module_default()).content,
                    children: [
                        hero && /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroGridList/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, hero), {
                            childrenClassName: (designers_styles_module_default()).filterAlphabet,
                            children: lettersList && /*#__PURE__*/ (0,jsx_runtime.jsx)(IndexList_IndexListAlphabetFilters, (0,_object_spread/* default */.Z)({
                                onClickLetter: function(value) {
                                    onChangeLetter(value);
                                },
                                currentLetter: currentLetter
                            }, lettersList))
                        })),
                        grid && /*#__PURE__*/ (0,jsx_runtime.jsx)(IndexList/* default */.Z, (0,_object_spread/* default */.Z)({
                            hasAlphabetFilter: true,
                            hasMultipleImages: true,
                            currentLetter: currentLetter
                        }, grid))
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageViewAnalytics/* PageViewAnalytics */.W, {
                template: "collection"
            })
        ]
    });
}
var __N_SSG = true;
/* harmony default export */ var designers = (DesignerListPage);


/***/ }),

/***/ 39100:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"GridListNav":"styles_GridListNav__rev1H","wrapper":"styles_wrapper__VrbkE","link":"styles_link__T7U1A","isActive":"styles_isActive__VkD6a"};

/***/ }),

/***/ 23802:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"HeroGridList":"styles_HeroGridList__YyXXf","left":"styles_left__rxXZh","right":"styles_right__kHznY","center":"styles_center__A96yO"};

/***/ }),

/***/ 4995:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"IndexListAlphabetFilters":"styles_IndexListAlphabetFilters__C8Rni","letter":"styles_letter__cdozn","letterAll":"styles_letterAll__y5qPk","isNotClickable":"styles_isNotClickable__5g_jD"};

/***/ }),

/***/ 6769:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"IndexListItem":"styles_IndexListItem__rrQBm","isActive":"styles_isActive__srW_B"};

/***/ }),

/***/ 97595:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"IndexList":"styles_IndexList__0yXFL","marker":"styles_marker__vNwhl","grid":"styles_grid__m_Zwp","images":"styles_images__HKwCS","imageWrapper":"styles_imageWrapper__tVkQK","hasMultipleImages":"styles_hasMultipleImages__UKcW_","hasImageHasBackground":"styles_hasImageHasBackground__Srj_x","ratio":"styles_ratio__dH9jk","list":"styles_list__FG9sK","item":"styles_item__UkCUy","isBannerVisible":"styles_isBannerVisible__M6jBN"};

/***/ }),

/***/ 51485:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"DesignerListPage":"styles_DesignerListPage__3rLTY","filterAlphabet":"styles_filterAlphabet__HTSYT","stickyNav":"styles_stickyNav__0YAh7"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7924,9645,9774,2888,179], function() { return __webpack_exec__(25498); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);